import { SearchableRequest } from 'app/model';

export * from 'app/model';

export interface DAT {
    id: string;
    wellStringId: string;
    wellLongName: string;
    fieldLongName: string;
    platformLongName: string;
    stringShortName: string;
    stringLongName: string;
    plannedDate: string;
    startDate: string | null;
    endDate: string | null;
    activityType: string;
    activityStatus: string;
    statusUpdatedAt: string;
    inputDate: string;
    activityId: string;
    dailyActivityTrackerDetails: DailyActivityTrackerDetail[];
}

export interface DailyActivityTrackerDetail {
    id: string;
    dailyActivity: string;
    activityDate: string;
}

export interface DATRecords {
    records: DAT[];
}

export interface DATRequest {
    id?: string;
    startDate?: string;
    endDate?: string;
    activityStatus?: string,
    statusUpdatedAt?: string,
    dailyActivityTrackerDetails?: DailyActivityTrackerDetail[];
}

export interface Activity {
    id: string;
    wellStringId: string;
    wellLongName: string;
    fieldLongName: string;
    platformLongName: string;
    stringShortName: string;
    stringLongName: string;
    activityDate: string;
    dailyActivity: string;
    activityType: string;

}



export interface ActivitySearchableRequest extends SearchableRequest {
    search: { activityDate: string };
}

export enum DATType {
    pm = 'PM',
    wrsv = 'WRSV',
    apr = 'APR',
    cm = 'CM',
    adhoc = 'Ad-hoc'
}